import * as ActionTypes from '../constants/actionTypes';
import {paymentService}  from '../services/paymentService';
import objectAssign from 'object-assign';
import { toast } from 'react-toastify';
import { convertCCExpireDate,getCCExpireDate } from '../utils/dates';


export function savePaymentDetails(name){
    return (dispatch, getState)=>{
        if(!getState().paymentDetail.validated){
            if(getState().paymentDetail.data.paymentMethodID){
                return dispatch(updateCardPayment(name))
                    .then(()=>{return dispatch(getPaymentDetails());})
                    .catch((error)=>{
                        console.error('error, ', error);
                        throw error;
                    });
            } else {
                return dispatch(createCardPayment(name,getState().paymentDetail))
                    .then(()=>{
                        return dispatch(getPaymentDetails());
                    }).catch((error)=>{
                        console.error('createCardPayment error, ', error);
                        throw error;
                    });
            }
        }
        return dispatch(getPaymentDetails());
    };
}
export function createCardPayment(name, paymentDetail) {
    return dispatch => {
        dispatch(request());
        let paymentMethod = {
            accountName: name,
            name: name,
            topup: 5,
            threshold: 5,
            cvv2: paymentDetail.cvc,
            expiryMonth: convertCCExpireDate(paymentDetail.expiryDate).month()+1,

            expiryYear: convertCCExpireDate(paymentDetail.expiryDate).year(),
            cardNumber: paymentDetail.cardNumber.replace(/ /g, ''),
            type: "CreditCard",
            settlementType: 3
        };
        return paymentService.createCardPayment(paymentMethod)
            .then(() => {
                dispatch(success());
            })
            .catch((error) => {
                dispatch(failure(error));
                throw error;
            });
    };
    function request() { return { type: ActionTypes.CREATE_PAYMENT_REQUEST }; }
    function success() { return { type: ActionTypes.CREATE_PAYMENT_SUCCESS }; }
    function failure(error) {
        const errors = error.response.data.errors;
        let errorCount = 0;
        for (let i = 0; i < errors.length; i++) {
            const e = errors[i];

            const startIndex = e.indexOf(", ") + 1;
            const endIndex = (e.lastIndexOf(":") ? e.lastIndexOf(":") : e.length);
            let extractedMessage = e.slice(startIndex, endIndex).trim();
                extractedMessage = (extractedMessage.length === 0 ? e : extractedMessage);

            toast.error(extractedMessage, {
                autoClose: 10000,
                hideProgressBar: false
            });
            errorCount++;
        } 

        if (errorCount === 0) {
            toast.error("Unable to create payment details", {
                autoClose: 10000,
            });
        }
        return { type: ActionTypes.CREATE_PAYMENT_FAILURE, error };
    }
}

export function updateCardPayment(name){
    return (dispatch,getState)=>{
        dispatch(request());
        let paymentMethodId = getState().paymentDetail.data.paymentMethodID;
        let paymentMethod = {
            accountName: getState().paymentDetail.data.accountName!=''?getState().paymentDetail.data.accountName:name,
            name: getState().paymentDetail.data.name!=''?getState().paymentDetail.data.name:name,
            topup: getState().paymentDetail.data.topup,
            threshold: getState().paymentDetail.data.threshold,
            cvv2: getState().paymentDetail.cvc,
            expiryMonth: convertCCExpireDate(getState().paymentDetail.expiryDate).month()+1,

            expiryYear: convertCCExpireDate(getState().paymentDetail.expiryDate).year(),
            cardNumber: getState().paymentDetail.cardNumber.replace(/ /g, ''),
            paymentMethodId: paymentMethodId,
            settlementType: getState().paymentDetail.data.settlementType,
            type: getState().paymentDetail.data.type
        };
        
        return paymentService.updateCardMethod(paymentMethodId,paymentMethod)
        .then(() => {
            dispatch(success());
        })
        .catch((error) => {
            dispatch(failure(error));
            throw error;
        });

    };
    function request() { return { type: ActionTypes.UPDATE_PAYMENT_REQUEST }; }
    function success() { return { type: ActionTypes.UPDATE_PAYMENT_SUCCESS }; }
    function failure(error) {
        toast.error("Unable to update payment detail", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.UPDATE_PAYMENT_FAILURE, error };
    }
}





export function getPaymentDetails() {
    return (dispatch, getState) => {
        if(getState().authentication.loggedIn){
            dispatch(request());
            return paymentService.getPaymentDetails()
            .then((response) => {
                let data = response.data;
                data = objectAssign({}, data, {
                    paymentType: data.type,
                    expiryDate: data.expiryYear && data.expiryYear!=0? getCCExpireDate(data.expiryYear, data.expiryMonth-1) : ''
                });
                dispatch(success(data));
            })
            .catch((error) => {
                dispatch(failure(error));
                throw error;
            });
        }
    };
    function request() { return { type: ActionTypes.GET_PAYMENT_DETAILS_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_PAYMENT_DETAILS_SUCCESS, data }; }
    function failure(error) {
        return { type: ActionTypes.GET_PAYMENT_DETAILS_FAILURE, error };
    }
}


// WEBPACK FOOTER //
// ./src/actions/paymentActions.js